import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCard = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(4 3.001)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M10,6.6H5.8A1.8,1.8,0,0,0,4,8.395V19.206A1.8,1.8,0,0,0,5.8,21h7.147a1.8,1.8,0,0,0,1.8-1.8v-.763",
					transform: "translate(-4 -3.001)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M9.3,16.976,15.8,18.73a2,2,0,0,0,2.453-1.416L20.933,7.27a2.008,2.008,0,0,0-1.412-2.446L13.012,3.07a2,2,0,0,0-2.453,1.416L7.883,14.53A2,2,0,0,0,9.3,16.976Z",
					transform: "translate(-4 -3.001)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M11.4,17.54l3.72-13.9",
					transform: "translate(-4 -3.001)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H24V24H0Z"
		})
	]
});
export default SvgCard;
